<template>
    <div>

    </div>
</template>
<script>
    import labApi from '@/api/container/container.js'
    import moment from 'moment'
    import {mapActions,mapState} from "vuex";
    export default {
        name:"mixins",
        data(){
            return {
                progressTxt:'',
                jupyter_contest_lab_id:'',
                storage_prefix:'jupyter_contest_lab_id_',
                endTime:'',
                readyContainer:{
                    lab_id:'',
                },
            }
        },
        computed: {
            ...mapState({
                del_contest_lab_id:state => state.container.del_contest_lab_id,
                heartbeatStatus:state => state.contestAdminContest.heartbeatStatus,
            }),
        },
        methods:{
            ...mapActions({
                DeleteContainer: 'container/DeleteContainer',
                setContestLabHeartbeat:'contestAdminContest/setContestLabHeartbeat'
            }),
            apiErrModal(msg){
                let _this = this;
                this.$Modal.error({
                    title: '请求错误',
                    content: msg,
                    onOk: () => {
                        _this.errorOk()
                    },
                });
            },
            errorOk(){
                // sessionStorage.clear();
                sessionStorage.removeItem(this.storage_prefix+this.contestInfo.id);
            },
            beforeunloadHandler(){
                this._beforeUnload_time=new Date().getTime();
            },
            //浏览器关闭删除容器
            unloadHandler(e) {
                this._gap_time = new Date().getTime() - this._beforeUnload_time;
                //判断是窗口关闭还是刷新
                if (this._gap_time <= 5) {
                    this.DeleteContainer({
                        data:{
                            url:this.contestInfo.mcp_endpoint.domain_name,
                            lab_id:this.jupyter_contest_lab_id,
                            contest_id:this.contestInfo.id,
                            key:this.storage_prefix,
                        },
                        callback:()=>{},
                        error:()=>{}
                    });
                }
            },
            // 心跳
            HeartbeatInterval(domain_name){
                if(this.jupyter_contest_lab_id) {
                    console.log("进入跳动");
                    let _this = this;
                    let endTime = new Date(_this.endTime);
                    // 如果当前有心跳
                    if(_this.heartbeatStatus == true){
                        return;
                    }
                    let timer = setInterval(function () {
                        let nowTime = new Date();
                        let t = endTime.getTime() - nowTime.getTime();
                        if (t > 0 && _this.jupyter_contest_lab_id !== _this.$store.state.container.del_contest_lab_id) {
                            console.log("嘭~ 状态:"+_this.heartbeatStatus);
                            labApi.heartbeat({
                                url: domain_name,
                                lab_id: _this.jupyter_contest_lab_id,
                            }).then(res => {
                                if (res.data.status.code != 2000000) {
                                    sessionStorage.removeItem(this.storage_prefix+_this.contestInfo.id);
                                    // 容器已经销毁
                                    _this.progressTxt = '容器已经销毁';
                                    _this.$Message.error("容器已经销毁");
                                    _this.setContestLabHeartbeat(false);
                                    clearInterval(timer);
                                }else{
                                    _this.setContestLabHeartbeat(true);
                                }
                            }).catch(err => {
                                _this.$Message.error(err);
                                _this.setContestLabHeartbeat(false);
                                clearInterval(timer);
                            })
                        } else {
                            _this.setContestLabHeartbeat(false);
                            clearInterval(timer);
                        }
                    }, 10000)
                }
            },
            // 删除容器
            // labDelete(labId){
            //
            // },
            // 创建容器
            getLabApply(url,contest_id) {
                let _this = this;
                labApi.create_container({
                    "url": url,
                    "contest_id": contest_id,
                }).then(res =>{
                    if(res.data.status.code == 2000000){
                        this.percent += Math.floor(Math.random() * 10) + 1
                        this.progressTxt = '请求中';
                        _this.jupyter_contest_lab_id = (res.data.body.lab_id).toString();
                        sessionStorage.setItem(this.storage_prefix+this.contestInfo.id, res.data.body.lab_id);

                        this.getLabQuery(url);
                    }else{
                        _this.progressTxt = res.data.status.message;
                        _this.apiErrModal(res.data.status.message)
                    }
                });
            },
            //查询容器
            getLabQuery(domain_name){
                let _this = this;
                let labId = sessionStorage.getItem(this.storage_prefix+_this.contestInfo.id);
                let timer =  setTimeout(function(){
                    console.log("del_lab_id==="+_this.$store.state.container.del_contest_lab_id);
                    if(labId == _this.$store.state.container.del_contest_lab_id){
                        clearTimeout(timer);
                        return;
                    }
                    labApi.query_container({
                        "url":domain_name,
                        "lab_id":labId
                    }).then(res =>{
                        let data = res.data;
                        if(data.status.code == 2000000){
                            _this.percent = 100;
                            _this.progressTxt = '就绪';
                            let formatDate = moment(data.body.end_at).format('YYYY/MM/DD HH:mm:ss');
                            let nowTime = new Date().getTime();
                            let endTime = new Date(nowTime + 2000 * 60).getTime();
                            _this.readyContainer = data.body;
                            _this.endTime = formatDate;
                            _this.SetUrl(data.body.address);
                            _this.HeartbeatInterval(domain_name);
                            clearTimeout(timer)
                        }else{
                            if(data.status.code == 5000107){
                                _this.errorModal = true;
                                _this.errorMsg = data.status.message;
                                clearTimeout(timer)
                            }else if(data.status.code == 5000111){
                                if (_this.percent > 90) {
                                    _this.percent = 95
                                } else {
                                    _this.percent += Math.floor(Math.random() * 10) + 1
                                }
                                _this.progressTxt = '审核中';
                                _this.getLabQuery(domain_name);
                            }else{
                                _this.apiErrModal(data.status.message);
                                clearTimeout(timer)
                            }
                        }
                    }).catch(err =>{
                        if(err){
                            _this.apiErrModal('请求异常，请稍后再试！');
                            clearTimeout(timer);
                        }
                    })
                }, 2000);
                // 侦听
                _this.$once('hook:beforeDestroy',function(){
                    console.log("销毁定时器");
                    clearTimeout(timer);
                })
            },
        },
        mounted(){
            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.addEventListener('unload', e => this.unloadHandler(e));
            this.jupyter_contest_lab_id = sessionStorage.getItem(this.storage_prefix+this.contestInfo.id);
        },
        destroyed() {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.removeEventListener('unload', e => this.unloadHandler(e));
        }
    }
</script>
